export class ItemAvaliacaoModel {
    id: Number
    nome: String
    class: String

    public static getListaAvaliacoes(): Array<ItemAvaliacaoModel> {
        const avaliacoes = []

        let item = new ItemAvaliacaoModel()
        item.id = 1
        item.nome = 'ruim'
        item.class = 'ruim'
        avaliacoes.push(item)

        item = new ItemAvaliacaoModel()
        item.id = 2
        item.nome = 'não curti'
        item.class = 'nao-curti'
        avaliacoes.push(item)

        item = new ItemAvaliacaoModel()
        item.id = 3
        item.nome = 'ok'
        item.class = 'ok'
        avaliacoes.push(item)

        item = new ItemAvaliacaoModel()
        item.id = 4
        item.nome = 'gostei'
        item.class = 'gostei'
        avaliacoes.push(item)

        item = new ItemAvaliacaoModel()
        item.id = 5
        item.nome = 'adorei'
        item.class = 'adorei'
        avaliacoes.push(item)

        return avaliacoes;
    }
}